/**
 * Get inCall Flag from Store
 * @param {object} state Global Store
 * @returns {boolean} inCall Flag
 */
export const isInCall = (state) => state.guest.inCall;
